// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__39Av1","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__Hs-Pg"};